import React from "react";
import { Box, Button, Divider, Paper, Stack, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

export default function AboutPage() {
  return (
    <Box sx={{ width: "100%", minHeight: "100vh", px: { xs: 1.5, md: 3 }, py: { xs: 2, md: 3 }, bgcolor: "#FFFFFF" }}>
      <Box sx={{ width: "100%" }}>
        <Typography sx={{ color: "#5B36F2", fontSize: 14, fontWeight: 700, mb: 0.75 }}>ABOUT</Typography>
        <Paper elevation={0} sx={{ p: { xs: 3, sm: 5 }, border: "1px solid #E1E7F5", borderRadius: 2 }}>
          <Stack spacing={3}>
            <Stack spacing={1.25} sx={{ mb: 1 }}>
              <Typography variant="h3" sx={{ fontWeight: 800, color: "#102A5C", fontSize: { xs: "2rem", sm: "2.5rem" }, mb: 1 }}>
                About Enki RPO
              </Typography>
              <Typography variant="body2" color="text.secondary">AI Recruiting Operating System</Typography>
              <Typography variant="body1" sx={{ color: "#344563", lineHeight: 1.7 }}>
                Enki RPO brings recruiting work into one connected workspace. Teams can manage jobs, candidates,
                outreach, activities, and reporting while using AI-assisted tools to keep their pipeline moving.
              </Typography>
            </Stack>

            <Box>
              <Typography variant="h6" sx={{ fontWeight: 750, color: "#102A5C", mb: 0.75 }}>Built for recruiting teams</Typography>
              <Typography variant="body1" sx={{ color: "#344563", lineHeight: 1.7 }}>
                From the first conversation to a successful placement, Enki RPO helps teams organize their work,
                collaborate with confidence, and focus on building great candidate and client relationships.
              </Typography>
            </Box>

            <Box>
              <Typography variant="h6" sx={{ fontWeight: 750, color: "#102A5C", mb: 0.75 }}>Our approach</Typography>
              <Typography variant="body1" sx={{ color: "#344563", lineHeight: 1.7 }}>
                We design the platform to make recruiting operations more visible, consistent, and human. AI assists
                with the repetitive work so your team can spend more time on thoughtful hiring decisions.
              </Typography>
            </Box>

            <Divider sx={{ mt: 1 }} />
            <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5}>
              <Button component={RouterLink} to="/privacy-policy" variant="outlined">Privacy Policy</Button>
              <Button component={RouterLink} to="/terms-of-service" variant="outlined">Terms of Service</Button>
              <Button component={RouterLink} to="/login" variant="text">Back to login</Button>
            </Stack>
          </Stack>
        </Paper>
      </Box>
    </Box>
  );
}
